import { useCallback } from 'react';
import {
  useRackAssignmentsQuery,
  useUpsertRackAssignments
} from '@api/bff/rackAssignments/useRackAssignments';
import type { RackCellAssignmentDto } from '@api/bff/rackAssignments/useRackAssignments';

export const useAssignCellScript = (jobNumber: string) => {
  const { data: rackAssignment } = useRackAssignmentsQuery(jobNumber);
  const upsertAssignments = useUpsertRackAssignments(jobNumber);

  const assignScript = useCallback(
    async (cell: string, equipmentRef: string, scriptGlobalId: string) => {
      const otherCells = (rackAssignment?.cells ?? []).filter(
        entry => entry.cell !== cell
      );
      const cells: RackCellAssignmentDto[] = [
        ...otherCells,
        { cell, equipmentRef, scriptGlobalId, overridden: true }
      ];
      await upsertAssignments.mutateAsync({ cells });
    },
    [rackAssignment, upsertAssignments]
  );

  return {
    assignScript,
    isAssigning: upsertAssignments.isPending
  };
};
